module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a9-5-0dbe244bbb45ea4d2239a03ab3fec142.jpg";